export const hasPermissions = (userPermissions: string[], required?: string[]) => {
  if (!required || required.length === 0) return true;
  return required.every(p => userPermissions.includes(p));
};
